<section class="p-2">
   <p-confirmDialog
      header="Confirmation"
      icon="pi pi-exclamation-triangle"></p-confirmDialog>
   <div
      class="spinner"
      *ngIf="isLoading">
      <div
         class="spinner-border"
         role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div>
   <div *ngIf="!isLoading">
      <div class="row mx-0 mb-2">
         <div class="col">
            <button
               [disabled]="saving"
               style="float: right"
               (click)="onSave()"
               class="btn btn-danger btn-lg">
               <ng-container *ngIf="saving"><span class="fa fa-spin fa-spinner"></span></ng-container>
               Save
            </button>
         </div>
      </div>
      <div class="viewport">
         <p-table
            #dt
            [loading]="tableLoading > 0"
            [showLoader]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [value]="items"
            [lazy]="true"
            [rows]="pageSize"
            (onLazyLoad)="pageRequested.next($event)"
            (onSort)="onSort()"
            sortField="prodLast12Months"
            [sortOrder]="-1">
            <ng-template pTemplate="header">
               <tr>
                  <th
                     pSortableColumn="practiceName"
                     [pSortableColumnDisabled]="isDirty">
                     <p-sortIcon field="practiceName"></p-sortIcon>
                     Practice Name
                  </th>
                  <th
                     pSortableColumn="initials"
                     [pSortableColumnDisabled]="isDirty">
                     <p-sortIcon field="initials"></p-sortIcon>
                     Initials
                  </th>
                  <th
                     pSortableColumn="firstName"
                     [pSortableColumnDisabled]="isDirty">
                     <p-sortIcon field="firstName"></p-sortIcon>
                     First Name
                  </th>
                  <th
                     pSortableColumn="lastName"
                     [pSortableColumnDisabled]="isDirty">
                     <p-sortIcon field="lastName"></p-sortIcon>
                     Last Name
                  </th>
                  <th
                     pSortableColumn="prodSince2016"
                     [pSortableColumnDisabled]="isDirty">
                     <p-sortIcon field="prodSince2016"></p-sortIcon>
                     Prod. Since 2016
                  </th>
                  <th
                     pSortableColumn="prodLast12Months"
                     [pSortableColumnDisabled]="isDirty">
                     <p-sortIcon field="prodLast12Months"></p-sortIcon>
                     Last 12 M Prod.
                  </th>
                  <th
                     pSortableColumn="serviceVisitPercent"
                     [pSortableColumnDisabled]="isDirty">
                     <p-sortIcon field="serviceVisitPercent"></p-sortIcon>
                     Service %
                  </th>
                  <th>Employee Type</th>
                  <th>Dayforce ID</th>
                  <th>Doc comp</th>
               </tr>
               <tr>
                  <th>
                     <p-multiSelect
                        appendTo="body"
                        [options]="practices"
                        placeholder="All"
                        styleClass="p-column-filter"
                        optionLabel="nameId"
                        optionValue="id"
                        (onChange)="onPracticeChange($event)"></p-multiSelect>
                  </th>
                  <th colspan="3">
                     <span class="full-width">
                        <p-iconfield>
                           <input
                              name="search-term"
                              id="search-term"
                              type="text"
                              class="full-width"
                              pInputText
                              [(ngModel)]="searchTerm"
                              (change)="onSerachChange($event)" />
                           <p-inputicon
                              styleClass="pi pi-times"
                              (click)="searchTerm = undefined; onSerachChange($event)"></p-inputicon>
                        </p-iconfield>
                     </span>
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>
                     <p-multiSelect
                        appendTo="body"
                        [options]="employeeTypes"
                        placeholder="All"
                        styleClass="p-column-filter"
                        (onChange)="onEmployeeTypeChange($event)"></p-multiSelect>
                  </th>
                  <th>
                     <div class="d-flex">
                        <p-checkbox
                           name="groupname"
                           inputId="groupname"
                           label="No Dayforce ID Only"
                           [binary]="true"
                           [ngModel]="showOnlyNoDayforceID"
                           (onChange)="onFilterShowOnlyNoDayforceID($event.checked)"></p-checkbox>
                        <label
                           for="groupname"
                           class="ml-2">
                           No Dayforce ID Only
                        </label>
                     </div>
                  </th>
                  <th></th>
               </tr>
            </ng-template>
            <ng-template
               pTemplate="body"
               let-item>
               <tr>
                  <td>{{ item.practiceName }}</td>
                  <td>{{ item.initials }}</td>
                  <td>{{ item.firstName }}</td>
                  <td>{{ item.lastName }}</td>
                  <td>{{ item.prodSince2016 | currency }}</td>
                  <td>{{ item.prodLast12Months | currency }}</td>
                  <td>{{ item.serviceVisitPercent | percent }}</td>
                  <td>
                     <p-select
                        [disabled]="saving"
                        appendTo="body"
                        [options]="employeeTypes"
                        placeholder="Select"
                        styleClass="p-column-filter"
                        [(ngModel)]="item.employeeTypeSkey"
                        (onChange)="onItemChange(item)"></p-select>
                  </td>
                  <td>
                     <p-autoComplete
                        [disabled]="saving"
                        appendTo="body"
                        [(ngModel)]="item.dayforceResult"
                        [suggestions]="dayforceResults"
                        (completeMethod)="searchDayforceEmployees(item.practiceSkey, $event)"
                        [forceSelection]="true"
                        (onSelect)="onDayforceIdChange(item, $event)"
                        (onClear)="onDayforceIdChange(item, { id: undefined })"
                        field="label"></p-autoComplete>
                  </td>
                  <td>
                     <p-checkbox
                        name="docCompGrp"
                        label=""
                        [binary]="true"
                        [(ngModel)]="item.docComp"
                        (onChange)="onItemChange(item)"></p-checkbox>
                  </td>
               </tr>
            </ng-template>
         </p-table>
      </div>
   </div>
</section>
